export default "__VITE_ASSET__oiKu_vu$__"